/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FilterLogicalOperator,
    FilterLogicalOperatorFromJSON,
    FilterLogicalOperatorFromJSONTyped,
    FilterLogicalOperatorToJSON,
    SortingDto,
    SortingDtoFromJSON,
    SortingDtoFromJSONTyped,
    SortingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetUserPermissionRelationsQuery
 */
export interface GetUserPermissionRelationsQuery {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserPermissionRelationsQuery
     */
    userIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserPermissionRelationsQuery
     */
    permission?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserPermissionRelationsQuery
     */
    page?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserPermissionRelationsQuery
     */
    pageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserPermissionRelationsQuery
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserPermissionRelationsQuery
     */
    take?: number;
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof GetUserPermissionRelationsQuery
     */
    filterLogicalOperator?: FilterLogicalOperator;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetUserPermissionRelationsQuery
     */
    filterKeys?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SortingDto>}
     * @memberof GetUserPermissionRelationsQuery
     */
    sortings?: Array<SortingDto> | null;
}

export function GetUserPermissionRelationsQueryFromJSON(json: any): GetUserPermissionRelationsQuery {
    return GetUserPermissionRelationsQueryFromJSONTyped(json, false);
}

export function GetUserPermissionRelationsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserPermissionRelationsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIds': !exists(json, 'userIds') ? undefined : json['userIds'],
        'permission': !exists(json, 'permission') ? undefined : json['permission'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'filterLogicalOperator': !exists(json, 'filterLogicalOperator') ? undefined : FilterLogicalOperatorFromJSON(json['filterLogicalOperator']),
        'filterKeys': !exists(json, 'filterKeys') ? undefined : json['filterKeys'],
        'sortings': !exists(json, 'sortings') ? undefined : (json['sortings'] === null ? null : (json['sortings'] as Array<any>).map(SortingDtoFromJSON)),
    };
}

export function GetUserPermissionRelationsQueryToJSON(value?: GetUserPermissionRelationsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userIds': value.userIds,
        'permission': value.permission,
        'page': value.page,
        'pageSize': value.pageSize,
        'skip': value.skip,
        'take': value.take,
        'filterLogicalOperator': FilterLogicalOperatorToJSON(value.filterLogicalOperator),
        'filterKeys': value.filterKeys,
        'sortings': value.sortings === undefined ? undefined : (value.sortings === null ? null : (value.sortings as Array<any>).map(SortingDtoToJSON)),
    };
}


